import { HttpService } from "$lib/shared/services/rest.service";

export const httpDelete = (action, config) => HttpService.delete(action, config);
export const httpGet = (action, config) => HttpService.get(action, config);
export const httpPost = (action, data, config) => HttpService.post(action, data, config);
export const httpPut = (action, data) => HttpService.put(action, data);